import json from './sprite.js';

export default {
    handle: 'es_SPT14-Homework',
    label: 'es_SPT14-Homework',
    json,
};
